import { render, staticRenderFns } from "./PurPD_Vendor.vue?vue&type=template&id=12621b5e"
import script from "./PurPD_Vendor.vue?vue&type=script&lang=js"
export * from "./PurPD_Vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports